import React from 'react';
import { WidgetOverlay } from './WidgetOverlay';
import { WidgetBaseProps } from './WidgetContainer';

export interface WithOptionsWidgetProps extends WidgetBaseProps {
  settingsDialogIsOpen?: boolean,
  setSettingsDialogIsOpen: (settingsDialogIsOpen:boolean) => void,
}

export interface WithOptionsWidgetOptions {
  hasSettingsDialog?: boolean,
}

// eslint-disable-next-line
export default function withOptionsWidget<T extends WidgetBaseProps>(WrappedComponent: any, settings:WithOptionsWidgetOptions) {
  return function WithOptionsWidget(props: WidgetBaseProps): JSX.Element {

    const [settingsDialogIsOpen, setSettingsDialogIsOpen] = React.useState<boolean>(false);

    return (
      <>
        <WrappedComponent {...props}
          settingsDialogIsOpen={settingsDialogIsOpen}
          setSettingsDialogIsOpen={setSettingsDialogIsOpen}
          ></WrappedComponent>
        <WidgetOverlay
          {...props as WidgetBaseProps}
          hasSettingsDialog = {settings.hasSettingsDialog}
          hasQueryDialog = {false}
          onSettingsOpened = {() => !settingsDialogIsOpen && setSettingsDialogIsOpen(true)}
        ></WidgetOverlay>
      </>
    );
  };
};

